import { DashboardSdk } from '@bringg/frontend-utils';
import { CreateTaskInventory, Customer, Task } from '@bringg/types';
import faker from 'faker';
import { shuffle } from 'lodash';

import { CreateMultipleTasksYieldResult, CreateTaskArguments, DeliveryOptions, ECommerceSettings } from 'Types';
import { sleep } from '../helpers';
import { getRandomAddresses } from './getRandomAddressNear';

export async function* createMultipleRandomTasksAndProcessThem(
  settings: ECommerceSettings,
  dashboardSDK: DashboardSdk,
  customer: Customer,
  inventories: CreateTaskInventory[],
  deliveries: DeliveryOptions[],
  createTask: (...args: CreateTaskArguments) => Promise<Task>,
  onProgress?: (percentages: Array<number>) => void
): AsyncGenerator<CreateMultipleTasksYieldResult, void, void> {
  const count = settings.ordersToBeCreated;
  const randomAddresses = await getRandomAddresses(customer.address as string);
  const progress = Array.from({ length: count }).map(() => 0);
  onProgress && onProgress(progress);
  const merchant = await dashboardSDK.sdk.merchant.get();

  for (let i = 0; i < count; i++) {
    const randomizedCustomer: Customer = {
      ...customer,
      merchant_id: merchant.id,
      phone: undefined,
      address:
        randomAddresses[faker.datatype.number({ min: 0, max: randomAddresses.length - 1 })]?.address || undefined,
      name: faker.fake('{{name.firstName}} {{name.lastName}}'),
    };

    const onSingleProgress = (percentage: number) => {
      progress[i] = percentage;
      onProgress && onProgress(progress);
    };

    yield { done: false };
    createTask(settings, randomizedCustomer, inventories, shuffle(deliveries)[0], dashboardSDK, onSingleProgress);
    await sleep(settings.sleepBetweenTasksStatusCreation * 1000);
  }

  yield { done: true };
}
